export const WorkspaceConfig_SearchV2 = {
    name: 'workspace-key--search',
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            {
                name: 'LeftPanel', key: 'searchAndResults', visible: true, factor: 1.5 / 5, min: 450,
                data: {}
            },
            {
                name: 'RightPanel', key: 'selectedResultViewer', visible: true, factor: 3.5 / 5, min: 1100,
                data: {}
            },
        ]
    }
};
